import Page from './jeito-dimas'
export default Page
